<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'"
(onHide)="closePaymentDialogue()" [dismissible]="false" [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <h3>Payment-Plan</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-payment-plan-add-update [currentAddUpdatePayment]="paymentSupportData" (changeModalStatus)="changeAddUpdateModelState($event)"></app-payment-plan-add-update>        
    </ng-template>
</p-sidebar>

<app-payment-plan-list [paymentPlanListData]="recordList" 
    (changeModelStatus)="changeAddUpdateModelState($event)"></app-payment-plan-list>
   
    